<template>
  <div class="main-graph-window">
    <div v-click-outside="closeMatrix" v-if="matrixView">
      <matrix-view-component
        :matrix-view="matrixView"
        :main-sector="mainSector"
        :sub-sector="selectedTab"
      />
    </div>

    <div class="chart-section">
      <div
        class="deposit-chart"

      >
        <div class="for-presets">
          <div class="presets-container dropdown">
            <!--          <button-->
            <!--            class="btn btn-info pre-btn dropdown-toggle"-->
            <!--            data-toggle="dropdown"-->
            <!--          >-->
            <!--            PRESETS-->
            <!--          </button>-->
            <div class="dropdown-menu sub-menu-presets-tab">
              <button
                class="btn btn-block preset-tab"
                v-for="subTab in presetsTabs"
                :key="subTab.id"
                @click.stop="setPresetFromTab(subTab, tab)"
                :class="{
                  active: validPreset(mainCalendarSection) === subTab.alias
                }"
              >
                {{ subTab.name }}
              </button>
              <button
                class="btn btn-block preset-tab stats-btn"
                @click="setMatrixView(selectedTab)"
                v-if="checkForMatrix(selectedTab)"
              >
                STATS
              </button>

<!--              all tabs-->
              <div class="dropdown">

              <button
                  class="btn btn-block preset-tab tabs-sector-main dropdown-toggle"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :class="{active:!selectedStats}"
              >

                {{ tabName }}
                <span
                    class="dropdown-item-right"
                ><i class="fas fa-caret-down"></i
                ></span>

              </button>

                <div class="dropdown-menu tabs-menu" aria-labelledby="dropdownMenuButton">
                <a
                    class="btn btn-block preset-tab sub-sector dropdown-item"
                    v-for="tab in graphTabs"
                    :key="tab"
                    @click="[TabClick(tab),selectedStats = false,tabName = tab.name]"
                    @mouseenter="hoveringTab = tab.alias"
                    @mouseleave="hoveringTab = false"
                    :class="{
                  active: selectedTab === tab.alias.toUpperCase(),
                  loading: selectedTab === tab.alias.toUpperCase(),
                  'cal-match':
                   selectedCalendarType.alias === mainCalendarSection &&
                   selectedTab === tab.alias
                          }"
                    v-if="tab.alias !== 'COUNTRIES'"
                >
                  <i
                      class="fas fa-times cancel-filter"
                      v-if="checkFilterTab(tab.alias)"
                      @click.stop="resetTabFilter(tab.alias)"
                  ></i>

                  {{ tab.name }}
                  <span
                      class="dropdown-item-right"
                      v-if="
              tab.hasOwnProperty('subMenu') || tab.hasOwnProperty('presetTabs')
            "
                  ><i class="fas fa-caret-right"></i
                  ></span>

                </a>
                </div>
              </div>
              <div class="dropdown">

              <button
                  class="btn btn-block preset-tab tabs-sector-main dropdown-toggle"
                  id="dropdownMenuButton2"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :class="{active:selectedStats}"
              >

                {{ statsTabName }}
                <span
                    class="dropdown-item-right"
                ><i class="fas fa-caret-down"></i
                ></span>

              </button>

                <div class="dropdown-menu tabs-menu" aria-labelledby="dropdownMenuButton2">
                <a
                    class="btn btn-block preset-tab sub-sector dropdown-item"
                    v-for="tab in ext_tabs"
                    :key="tab"
                    @click="[TabClick(tab),selectedStats = true,statsTabName = tab.name]"
                    @mouseenter="hoveringTab = tab.alias"
                    @mouseleave="hoveringTab = false"
                    :class="{
                  active: selectedTab === tab.alias.toUpperCase(),
                  loading: selectedTab === tab.alias.toUpperCase(),
                  'cal-match':
                   selectedCalendarType.alias === mainCalendarSection &&
                   selectedTab === tab.alias
                          }"
                    v-if="tab.alias !== 'COUNTRIES'"
                >
                  <i
                      class="fas fa-times cancel-filter"
                      v-if="checkFilterTab(tab.alias)"
                      @click.stop="resetTabFilter(tab.alias)"
                  ></i>

                  {{ tab.name }}
                  <span
                      class="dropdown-item-right"
                      v-if="
              tab.hasOwnProperty('subMenu') || tab.hasOwnProperty('presetTabs')
            "
                  ><i class="fas fa-caret-right"></i
                  ></span>

                </a>
                </div>

              </div>
<!--              end all tabs-->

              <span class="for-line-btns" v-if="checkForSubMenu(selectedTab)">
                <button
                  class="btn btn-block preset-tab stats-btn-for-line"
                  v-if="checkForSubMenu(selectedTab)"
                  v-for="(subTab, idx) in checkForSubMenu(selectedTab)[
                    'subMenu'
                  ]"
                  :key="idx"
                  @click="clickSubTab(checkForSubMenu(selectedTab), subTab)"
                >
                  {{ subTab.name }}
                </button>
              </span>
            </div>
            <div v-if="dPcounters.units > 0" class="top-bar">
              <div class="inner-bar">total Deposit: {{ dPcounters.dp }}</div>
              <div class="inner-bar">
                <span v-if="selectedTab === 'USERS'">total users</span>
                <span v-if="selectedTab === 'BROKERS'">total brokers</span>
                <span v-if="selectedTab === 'STATUS'">total status</span>
                <span v-if="selectedTab === 'QUANTITY'">total quantity</span>
                <span v-if="selectedTab === 'SUPPORT'">total supports</span>
                <span v-if="selectedTab === 'CONVERT'">total converts</span>
                <span v-if="selectedTab === 'SECUSERS'">total secusers</span>
                <span v-if="selectedTab === 'LEADING'">total leadings</span>
                <span v-if="selectedTab === 'TIMELINE'">total units</span>
                : {{ dPcounters.units }}
              </div>
              <div class="inner-bar" v-if="dpDates">
                dates:
                {{ dpDates[0] }} -
                {{ dpDates[1] }}
                <span class="for-diff-in-days">{{ dpDates[2] }}</span>
              </div>
            </div>
          </div>
        </div>
        <canvas :class="{ sized_chart: selectedTab === 'USERS'  && !CheckUserPermission([7])}" class="for-canvas-dp" id="main-chart-dep-sub-gn"></canvas>
      </div>
      <div v-show="selectedTab === 'USERS'" class="trans-dep-chart">
        <canvas id="bar-chart-tran-dep-main"></canvas>
      </div>
      <div v-show="selectedTab === 'USERS'" class="dep-goal-chart">
        <canvas id="bar-chart-deposit-goal-main"></canvas>
      </div>
    </div>
    </div>
</template>

<script>
import apiClientCreator from "../../../../../../helpers/api/request";
import Chart from "chart.js";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment/moment";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CahartAnnot from "chartjs-plugin-annotation";
import ClickOutside from "vue-click-outside";
import vClickOutside from "v-click-outside";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import MatrixViewComponent from "../../components/matrix_view/MatrixViewComponent";
import calendarCheck from "@/mixins/tags/calendarCheck";
import presetsValidator from "@/mixins/presets/presetsValidator";

const UsersBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value,index){
          var res = (((value/index.dataset.data.reduce((a, b) => a + b))*100));
          if(res >= 100 ){
            res =  res.toString().slice(0,3);

          }else{
            res = (res >= 10) ? res.toString().slice(0,2) : res.toString().slice(0,1);
          }


          return value === 0 ? "" : value + " - " + res +"%"  ;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 10,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 1,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },

    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};
const depositsChartData = {
  type: "bar",
  options: {
    onClick: evt => {
      this.clickDepChart(evt);
    },
    layout: {
      padding: {
        top: 26
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        /*     backgroundColor: function (context) {
                           return context.dataset.backgroundColor;
                         },*/
        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },
    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.4)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 0,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 9
          }
        }
        /*   {

                      id: "bar-x-axis2",
                      stacked: true,
                      gridLines: {
                        display:false,
                        fontSize: 0
                      },
                      ticks: {
                       display:false
                      }
                    }*/
      ]
    },
    legend: {
      display: false
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    },
    tooltips: {
      mode: "index",
      intersect: false
    }
  }
};
const depositsDailyGoalChartData = {
  type: "bar",
  options: {
    layout: {
      padding: {
        top: 16
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        /*     backgroundColor: function (context) {
                           return context.dataset.backgroundColor;
                         },*/
        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            //display:false,
            beginAtZero: true,
            padding: 0,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1,
            suggestedMin: 0,
            suggestedMax: 30
          }
        }
      ],
      xAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 9
          }
        }
      ]
    },
    gradientColors: [
      "rgba(29,140,248,0.4)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    legend: {
      display: false
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};
const LineVolChartOpt = {
  type: "line",
  options: {
    layout: {
      padding: {
        top: 2
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return "#44A2D2";
        },
        formatter: function(value) {
          return value ? value : "";
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors:  [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            //display:false,
            // beginAtZero: true,
            padding: 15,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: true,
      position: "top",
      align: "end",
      labels: {
        boxWidth: 20,
        fontSize: 10
      },
      onHover: function(e) {
        e.target.style.cursor = "pointer";
      }
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};
export default {
  name: "DpCharts.component",
  props: {
    mainData: {
      required: true,
      type: Object
    },
    mainSector: {
      required: true,
      type: String
    },
    tabs: {
      type: Array,
      required: true
    },
    presetsTabs: {
      type: Array,
      required: true
    },
    statsTabs: {
      type: Array,
      required: true
    }
  },
  mixins: [UsersPermissionCheck, calendarCheck,presetsValidator],
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "showReset",
      "multiSelectChartData",
      "selectedCalendarType",
      "generalQueryObject",
      "clickFromChart",
      "updateDepAfterCongrats",
      "clickedOnMatrixCountries",

    ])
  },
  components: {
    MatrixViewComponent
  },

  data() {
    return {
      UsersBar: UsersBar,
      depositsChartData: depositsChartData,
      transferDailyChartOpt: {
        type: "bar",
        options: {
          layout: {
            padding: {
              top: 16
            }
          },
          plugins: {
            datalabels: {
              align: "end",
              anchor: "end",
              offset: -5,
              /*     backgroundColor: function (context) {
                                 return context.dataset.backgroundColor;
                               },*/
              font: {
                family: "Montserrat"
              },
              fontSize: 9,
              color: function(context) {
                return context.dataset.borderColor;
              },
              formatter: function(value) {
                return value === 0 ? "" : value;
              }
            }
          },
          maintainAspectRatio: false,
          gradientColors: [
            "rgba(29,140,248,0.4)",
            "rgba(29,140,248,0.0)",
            "rgba(29,140,248,0)"
          ],
          gradientStops: [1, 0.4, 0],
          responsive: true,
          scales: {
            yAxes: [
              {
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
                },
                ticks: {
                  //display:false,
                  beginAtZero: true,
                  padding: 0,
                  fontColor: "transparent", //"#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 1,
                  suggestedMin: 0,
                  suggestedMax: 20
                }
              }
            ],
            xAxes: [
              {
                // barPercentage: 1.0,
                // categoryPercentage: 0.5,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent"
                },
                ticks: {
                  padding: 0,
                  fontColor: "#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 9
                }
              }
            ]
          },
          legend: {
            display: false
          },
          hover: {
            onHover: function(e) {
              const point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = "pointer";
              else e.target.style.cursor = "default";
            }
          },
          tooltips: {
            position: "custom",
            enabled: true,
            mode: "single",
            fontSize: 6
            // callbacks: {
            //   label: (value, index) => {
            //
            //   }
            // }
          }
        }
      },
      depositsDailyGoalChartData: depositsDailyGoalChartData,
      LineVolChartOpt: LineVolChartOpt,

      mainCalendarSection: "DEP",
      rand: 0,
      chatLogDiv: null,
      graphTabs: [],
      hoveringTab: false,
      openSubTab: false,
      selectedSubTab: null,
      chartData: [],
      allData: [],
      depChart: null,
      selectedTab: null,
      mainFilters: {},
      globalDateRange: "TODAY",
      ext_tabs: [
        {
          id: 7,
          alias: "LINE",
          name: "LINE",
          subMenu: [
            {
              id: 1,
              alias: "TOTAL",
              name: "TOTAL",
              default: true
            },
            {
              id: 2,
              alias: "USERS",
              name: "USERS",
              default: false
            },
            {
              id: 3,
              alias: "AVG",
              name: "AVG",
              default: false
            }
          ],
          ex: true
        },
        {
          id: 7,
          alias: "TIMELINE",
          name: "TIMELINE",
          ex: true
        },
        // {
        //   id: 8,
        //   alias: "COUNT",
        //   name: "COUNT",
        //   ex: true
        // },
        // {
        //   id: 9,
        //   alias: "STATS",
        //   name: "STATS",
        //   ex: true
        // },
        //{
        //   id: 10,
        //   alias: "CR_AGENTS",
        //   name: "CR AGENTS",
        //   ex: true,
        //   presetTabs: true,
        //   statisticTab: true,
        //   onlyStats: true
        // },
        // {
        //   id: 11,
        //   alias: "CR_USERS",
        //   name: "CR USERS",
        //   ex: true,
        //   presetTabs: true,
        //   statisticTab: true,
        //   onlyStats: true
        // },
        {
          id: 12,
          alias: "DEP_VS_REG",
          name: "DEPvsREG",
          ex: true,
          presetTabs: true,
          statisticTab: true,
          onlyStats: true
        },
        {
          id: 13,
          alias: "COUNTRY_REPORT",
          name: "COUNTRIES",
          ex: true,
          presetTabs: true,
          statisticTab: true,
          onlyStats: true
        },
        {
          id: 14,
          alias: "DEP_REG_CHART",
          name: "DEP&REG",
          ex: true,
          presetTabs: true,
          statisticTab: true,
          onlyStats: true
        },
        {
          id: 15,
          alias: "DEP_VS_REG_CHART",
          name: "DEPvsREG",
          ex: true,
          presetTabs: true,
          statisticTab: true,
          onlyStats: true
        },
        {
          id: 16,
          alias: "TIME_MEASURE_REPORT",
          name: "T.MEASURE",
          ex: true,
          presetTabs: true,
          statisticTab: true,
          onlyStats: true
        },
        {
          id: 17,
          alias: "UN_PER",
          name: "UN PER",
          ex: true,
          presetTabs: true,
          statisticTab: true,
          onlyStats: true
        }
      ],

      tabsLength: 8,
      tabPaginate: 0,
      requestsForTabs: {},
      depositsStats: {},

      tranDepUsersStatsToday: [],
      goalChart: null,
      TransfersChart: null,
      DynamicChartBuild: null,

      matrixView: false,
      dPcounters: {
        dp: 0,
        units: 0
      },
      dpDates: null,
      selectedStats:false,
      tabName:'USERS',
      statsTabName:'LINE',

    };
  },
  created() {
    this.graphTabs = this.tabs;
  },
  mounted() {
    if (this.CheckUserPermission([1, 2, 3, 4, 12])) {
      //this.graphTabs = [...this.graphTabs, ...this.ext_tabs];
    }
    this.TabClick(this.graphTabs[0])
  },
  watch: {

    clickedOnMatrixCountries: function() {
      if (this.clickedOnMatrixCountries) {
        let tab = this.ext_tabs.find(key => {
          return key.alias === "COUNTRY_REPORT";
        });
        this.TabClick(tab);

        this.$store.commit("clients/setClickedOnMatrixCountries", false);
      }
    },
    multiSelectChartData: {
      handler() {
        if (
          this.multiSelectChartData.data[this.mainSector] &&
          !this.multiSelectChartData.fromChart &&
            this.mainSector === this.multiSelectChartData.selectedSector
        ) {
          this.initialChartData(this.multiSelectChartData);
        }
      },
      deep: true
    },
    selectedTab: function() {
      this.counters = {
        dp: 0,
        units: 0
      };
      this.selectedTab = this.selectedTab?this.selectedTab.toUpperCase():null;
    },
    updateDepAfterCongrats: function() {
      if (this.updateDepAfterCongrats) {
        let tab = this.tabs.find(key => {
          return key.alias === "USERS";
        });
        this.TabClick(tab);
        this.$store.commit("clients/setUpdateDepAfterCongrats", false);
      }
    }
  },
  methods: {
    diffTimeInDaysForNaChartTitle(d1, d2) {
      let date1 = new Date(d1);
      let date2 = new Date(d2);
      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays + 1 + "Days";
    },
    async initialChartData(data) {
      if (this.mainSector === data.selectedSector) {
        let element = document.getElementsByClassName(
          "btn btn-block preset-tab sub-sector active"
        );
        if (data.fromChart) {
          return;
        }
        $(element).removeClass("loading");
        let tabE = this.ext_tabs.filter(tab => {
          return tab.alias === this.selectedTab;
        });
        if (tabE.length > 0) {
          await this.fetchExternalGraphs(tabE[0]);
          return;
        }
        this.mainSector = data.selectedSector;
        this.allData = data;
        if (!data.data.hasOwnProperty(this.mainSector)) {
          return;
        }
        this.chartData = data.data[this.mainSector].data;
        this.selectedTab = data.data[this.mainSector].selectedTab;
        let tab = this.tabs.filter(tab => {
          return tab.alias === this.selectedTab;
        });
        if (tab.length > 0) {
          await this.fetchExternalGraphs(tab[0]);
        }
        let lineChartStatus = `main-chart-dep-sub-gn`;
        // if (this.statusChartTab) {
        //   this.statusChartTab.destroy();
        // }

        if (!this.chartData.hasOwnProperty(this.mainSector)) {
          this.createChart(
            lineChartStatus,
            this.UsersBar,
            this.chartData,
            this.selectedTab
          );

          if (this.selectedTab.toUpperCase() === "USERS") {
            let dailyGoal = 20;
            this.createGoalChart(
              "bar-chart-deposit-goal-main",
              this.depositsDailyGoalChartData,
              this.chartData,
              dailyGoal
            );
          }
        }
        return;
      }
    },
    async TabClick(tab) {

      // if (this.depChart) {
      //   this.depChart.destroy();
      // }
      // if (this.DynamicChartBuild) {
      //   this.DynamicChartBuild.destroy();
      // }
      if (
        (!tab.hasOwnProperty("ex") && !tab.ex) ||
        (tab.hasOwnProperty("ex") &&
          tab.hasOwnProperty("combine") &&
          tab.combine &&
          !tab.hasOwnProperty("onlyStats") &&
          !tab.onlyStats)
      ) {
        if (tab.hasOwnProperty("subMenu")) {
          this.openSubTab = true;
          //this.selectedSubTab = tab.subMenu[0].alias;
        }
        if (this.selectedTab !== tab.alias) {
          // this.$store.commit("clients/setSelectedCalendarType", {
          //   alias: "DEP",
          //   preset: "TODAY"
          // });
        }
        let element = document.getElementsByClassName(
          "btn btn-block preset-tab sub-sector active"
        );
        $(element).addClass("loading");
        this.selectedTab = tab.alias;
        let data = Object.assign({}, this.allData);
        data.selectedTab = tab.alias;
        data.fromChart = true;

        this.$store.commit("clients/setMultiSelectChartData", [
          data,
          this.mainSector
        ]);
      }
      if (tab.hasOwnProperty("ex") && tab.ex) {
        this.selectedTab = tab.alias;

        if (tab.hasOwnProperty("onlyStats") && tab.onlyStats) {
          this.setPresetFromTab(tab);
        }

        if (tab.hasOwnProperty("subMenu")) {
          this.openSubTab = true;

          //this.selectedSubTab = tab.subMenu[0].alias;
        }

        let data = Object.assign({}, this.allData);
        data.selectedTab = tab.alias;
        data.fromChart = true;
        this.$store.commit("clients/setMultiSelectChartData", [
          data,
          this.mainSector
        ]);

        await this.fetchExternalGraphs(tab);
      }
    },

    checkForSubMenu(mainTab) {
      let allTabs = [...this.tabs, ...this.ext_tabs];

      return allTabs.find(tab => {
        return tab.alias === mainTab && tab.hasOwnProperty("subMenu");
      });
    },
    checkForMatrix(mainTab) {
      let allTabs = [...this.tabs, ...this.ext_tabs];
      return allTabs.find(tab => {
        return tab.alias === mainTab && tab.hasOwnProperty("presetTabs");
      });
    },
    clickSubTab(mainTab, subTab) {
      this.openSubTab = true;
      this.selectedSubTab = subTab.alias;
      this.selectedTab = mainTab.alias;
      if (subTab.hasOwnProperty("presetTab") && subTab.presetTab) {
        if (this.selectedSubTab === "MATRIX") {
          this.setPresetFromTab(subTab);
          this.TabClick(mainTab);
        }

        return;
      }

      if (this.selectedTab === "LINE") {
        let tab = "LINE";
        if (!this.depositsStats[tab]) {
          this.TabClick(mainTab);
        } else {
          this.createDynamicVolChart(
            this.depositsStats[tab],
            `main-chart-dep-sub-gn`,
            this.LineVolChartOpt
          );
        }
      }
    },
    createChart(chartId, chartOpt, stats, tab) {
      let opt = chartOpt.options;
      let NewData = stats;
      let labels = [];
      let onlineCounts = [];
      let ccData = [];
      let ids = [];
      NewData = NewData.sort((a, b) => {
        if (a.count[0] > b.count[0]) {
          return -1;
        }
        if (a.count[0] < b.count[0]) {
          return 1;
        }
        return 0;
      });
      NewData.forEach(num1 => {
        if (num1.count[0] === 0) {
          return;
        }

        labels.push(
            tab === "users" ? this.newNameFormatter(num1.title) : num1.title.substring(0, 17)
        );
        onlineCounts.push(num1.count[0]);
        ccData.push(num1.count[2]);
        ids.push(num1.id);
      });

      if (this.generalQueryObject.hasOwnProperty("deposit_at_from")) {
        this.dpDates = [
          this.generalQueryObject.deposit_at_from
            .split("-")
            .reverse()
            .join("-"),
          this.generalQueryObject.deposit_at_to
            .split("-")
            .reverse()
            .join("-"),
          this.diffTimeInDaysForNaChartTitle(
            this.generalQueryObject.deposit_at_from,
            this.generalQueryObject.deposit_at_to
          )
        ];
      } else {
        this.dpDates = null;
      }

      this.dPcounters.units = NewData.length;
      if (tab === "users") {
        let sorted = onlineCounts.slice().sort(function(a, b) {
          return b - a;
        });
        onlineCounts.map((v, index) => {
          let rank = sorted.indexOf(v) + 1;
          if (rank > 3) {
            return;
          }
          labels[index] = "#" + rank + " " + labels[index];
        });
      }

      let dataForChart = [
        {
          type: "bar",
          label: "Count",
          data: onlineCounts, //onlineTrans,
          fill: true,
          borderColor: "rgb(189,58,255)",
          backgroundColor: "rgba(189,58,255,0.7)",
          borderWidth: 0.5,
          borderDash: [],
          borderDashOffset: 0.0,
          maxBarThickness: 20,
          xAxisID: "bar-x-axis1"
        }
      ];

      if (tab === "users" || tab === "brokers") {
        dataForChart.push({
          type: "bar",
          label: "Count",
          data: ccData, //onlineTrans,
          fill: true,
          borderColor: "rgb(7,7,7)",
          backgroundColor: "rgba(7,7,7,0.7)",
          borderWidth: 0.5,
          borderDash: [],
          borderDashOffset: 0.0,
          maxBarThickness: 20,
          xAxisID: "bar-x-axis1"
        });
      }
      const data = {
        labels: labels,
        datasets: dataForChart
      };

      if (this.depChart) {
        this.depChart.destroy();
      }
      if (opt.annotation) {
        opt.annotation = null;
      }
      if (onlineCounts.length > 0) {
        opt.annotation = this.returnAverageLine(
          onlineCounts.reduce((a, b) => a + b) / onlineCounts.length,
          true,
          "rgba(189,58,255,0.5)",
          25
        );
        if (tab !== "quantity") {
          this.dPcounters.dp = onlineCounts.reduce((a, b) => a + b);
        } else {
          this.dPcounters.dp = stats.reduce((a, b) => a + b.id * b.count[0], 0);
        }
        if (tab === "status") {
          this.dPcounters.dp = stats.reduce(
            (a, b) => a + (b.title !== "CC-DECLINE" ? b.count[0] : 0),
            0
          );
        }
      } else {
        this.dPcounters.dp = 0;
      }

      const ctx = document.getElementById(chartId);
      this.depChart = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
      ctx.onclick = evt => {
        this.clickOnChart(this.depChart, evt, ids);
      };
    },

    async fetchExternalGraphs(subSector) {
      // if (this.depChart) {
      //   this.depChart.destroy();
      // }
      let tab = subSector.alias.toUpperCase();
      let element = document.getElementsByClassName(
        "btn btn-block preset-tab sub-sector active"
      );
      $(element).addClass("loading");
      this.depUsersStatsToday = [];
      this.requestsForTabs[tab] = true;
      if (!this.showReset) {
        this.resetMainFilters();
      } else {
        this.mainFilters = this.generalQueryObject;
      }

      if (tab === "USERS") {
        await this.fetchTransfersDeposits();
      }
      if (tab === "LINE") {
        await this.fetchDynamicDepLine(tab);
      }
      if (tab === "TIMELINE") {
        this.multiSelectChartData.data.hasOwnProperty(this.sector);
        await this.fetchTimeDepLine(tab);
      }

      this.requestsForTabs[tab] = false;
      $(element).removeClass("loading");
    },

    namesFormatter(name, numLet = 3) {
      let first_name = name.split(" ")[0].substring(0, numLet);
      let second_name = "";
      name.split(" ").length > 1
        ? (second_name = name
            .split(" ")[1]
            .substring(0, 1)
            .toUpperCase())
        : (second_name = "");
      let fullName = first_name + " " + second_name;
      return fullName;
    },

    newNameFormatter(string){
      return string.replace(/^(\S+)\s+(\S).*/, '$1 $2.')
    },
    returnAverageLine: (avg, enabled, lineColor, pose, YAdjust = 10) => ({
      annotations: [
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: avg,
          borderColor: lineColor,
          borderWidth: 1,
          borderDash: [2, 2],
          label: {
            // Background color of label, default below
            backgroundColor: "rgba(0,0,0,0)",

            // Font family of text, inherits from global
            fontFamily: "Montserrat",

            // Font size of text, inherits from global
            fontSize: 10,

            // Font style of text, default below
            // fontStyle: "bold",

            // Font color of text, default below
            fontColor: "#000",

            // Padding of label to add left/right, default below
            xPadding: 4,

            // Padding of label to add top/bottom, default below
            yPadding: 4,

            // Radius of label rectangle, default below
            cornerRadius: 5,

            // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
            position: "center",

            // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
            // For horizontal lines positioned left or right, negative values move
            // the label toward the edge, and positive values toward the center.
            xAdjust: pose,

            // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
            // For vertical lines positioned top or bottom, negative values move
            // the label toward the edge, and positive values toward the center.

            yAdjust: YAdjust,

            // Whether the label is enabled and should be displayed
            enabled: enabled,

            // Text to display in label - default is null. Provide an array to display values on a new line
            content: avg.toFixed(0),

            // Rotation of label, in degrees, default is 0
            rotation: 90
          }
        },

        {}
      ]
    }),

    defaultPresets(range = this.globalDateRange) {
      if (range === "TODAY") {
        const n = new Date();
        const today = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          start: today,
          end: today
        };
      }
      if (range === "YESTERDAY") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1)
        );
        // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "WEEK") {
        const n = new Date();
        const start = moment()
          .startOf("isoWeek")
          .toDate();
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "MONTH") {
        const n = new Date();
        const startMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1));
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() - 1, 1)
        );
        const endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }

      if (range === "LAST_30_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 30)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_90_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 90)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_180_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 180)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "TOMORROW") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() + 1)
        );
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "NEXT_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 1)
        );
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 2, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
    },

    paginate(stats) {
      let pageSize = this.tabsLength;

      let inputArray = stats;

      let result = inputArray.reduce((resultArray, item, index) => {
        const pageIndex = Math.floor(index / pageSize);

        if (!resultArray[pageIndex]) {
          resultArray[pageIndex] = []; // start a new page
        }

        resultArray[pageIndex].push(item);

        return resultArray;
      }, []);

      return result;
    },
    capitalize(string) {
      string = string.toLowerCase();
      return string[0].toUpperCase() + string.slice(1);
    },
    async fetchTransfersDeposits() {
      let queryParamsToday = {};
      if (!this.showReset) {
        queryParamsToday = {
          last_transfer_from: moment().format("YYYY-MM-DD"),
          last_transfer_to: moment().format("YYYY-MM-DD"),
          transfer: 1,
          dep_trans_stats: 1
        };
      } else {
        queryParamsToday = this.generalQueryObject;
      }

      apiClientCreator(`client/stats/tag/tr/0/2`)
        .get("", { params: queryParamsToday })
        .then(res => {
          this.tranDepUsersStatsToday = res.data;
          // this.createTranDepChart(
          //   "bar-chart-tran-dep-main",
          //   this.transferDailyChartOpt,
          //   this.tranDepUsersStatsToday
          // );
        });
    },
    async fetchDynamicDepLine(tab) {
      let queryParamsToday = {};
      if (!this.showReset) {
        queryParamsToday = {
          deposit_at_from: moment().format("YYYY-MM-DD"),
          deposit_at_to: moment().format("YYYY-MM-DD"),
          special_req: true
        };
      } else {
        queryParamsToday = this.generalQueryObject;
      }
      await apiClientCreator(`client/stats/dynamic/volatility`)
        .get("", {
          params: queryParamsToday
        })
        .then(res => {
          this.depositsStats[tab] = res.data;
          if (this.depositsStats[tab].length > 0 && tab === "LINE") {
            if (this.statusChartTab) {
              this.statusChartTab.destroy();
            }
            if (this.depChart) {
              this.depChart.destroy();
            }
            this.createDynamicVolChart(
              this.depositsStats[tab],
              `main-chart-dep-sub-gn`,
              this.LineVolChartOpt
            );
          }
        });
    },

    async fetchTimeDepLine(tab) {
      let queryParamsToday = {};
      // if (!this.showReset) {
      //   // queryParamsToday = {
      //   //   deposit_at_from: moment().format("YYYY-MM-DD"),
      //   //   deposit_at_to: moment().format("YYYY-MM-DD"),
      //   //   special_req: true
      //   // };
      // } else {
      queryParamsToday = this.generalQueryObject;
      // }
      await apiClientCreator(`client/stats/deposits/volatility`)
        .get("", {
          params: queryParamsToday
        })
        .then(res => {
          this.depositsStats[tab] = res.data;
          if (this.depositsStats[tab].length > 0 && tab === "TIMELINE") {
            if (this.statusChartTab) {
              this.statusChartTab.destroy();
            }
            if (this.depChart) {
              this.depChart.destroy();
            }
            this.createDepositsVolChart(
              this.depositsStats[tab],
              `main-chart-dep-sub-gn`,
              this.LineVolChartOpt
            );
          }
        });
    },

    createTranDepChart(chartId, chartData, stats) {
      if (stats.length === 0) {
        return;
      }
      let usersNames = [];
      let transByCount = [];
      let dep_count = [];
      let filteredZeros = stats.filter(person => person.count !== 0);
      // const filterRole = filteredZeros.filter(person => person.user.role === 5);
      const sortedRole = filteredZeros.sort((a, b) => {
        if (a.overall_count > b.overall_count) {
          return -1;
        }
        if (a.overall_count < b.overall_count) {
          return 1;
        }
        return 0;
      });
      sortedRole.forEach(function(item) {
        usersNames.push(item.user.first_name.toUpperCase());
      });

      sortedRole.forEach(function(item) {
        transByCount.push(item.count);
        dep_count.push(item.dep);
      });
      const data = {
        labels: usersNames,

        datasets: [
          {
            type: "bar",
            data: transByCount,
            fill: true,
            borderColor: "#827717",
            backgroundColor: "rgba(130,119,23,0.7)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20
          },
          {
            type: "bar",
            data: dep_count,
            fill: true,
            borderColor: "#d900ff",
            backgroundColor: "rgba(232,0,255,0.7)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20
          }
        ]
      };
      if (this.TransfersChart) {
        this.TransfersChart.destroy();
      }
      const ctx = document.getElementById(chartId);
      this.TransfersChart = new Chart(ctx, {
        type: chartData.type,
        data: data,
        options: chartData.options,
        plugins: [ChartDataLabels]
      });
    },

    createGoalChart(chartId, chartData, stats, goal, opt) {
      if (stats.length > 0) {
        // let depCount = overallDep;

        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        let depCount = stats.map(s => s.count[0]).reduce(reducer);

        const data = {
          labels: ["DEP/GOAL"],
          datasets: [
            {
              type: "bar",
              label: "DEP",
              data: [depCount],
              borderColor: "#aa00ff",
              backgroundColor: "rgba(189,58,255,0.7)",
              borderWidth: 0.5,
              borderDash: [],
              borderDashOffset: 0.0,
              maxBarThickness: 20
            },
            {
              type: "bar",
              label: "Goal",
              data: [goal],
              /*            backgroundColor: "#f9a825",
                            borderColor: "rgba(17,17,17,0.74)",
                            maxBarThickness: 23,
                            borderWidth: 0.5*/
              fill: true,
              borderColor: "#f9a825",
              backgroundColor: "rgba(249,168,37,0.7)",
              borderWidth: 0.5,
              borderDash: [],
              borderDashOffset: 0.0,
              maxBarThickness: 20
            }
          ]
        };

        const ctx = document.getElementById(chartId);
        this.goalChart = new Chart(ctx, {
          type: chartData.type,
          data: data,
          options: chartData.options
        });
        ctx.onclick = evt => {
          this.clickGoalChart(opt, this.goalChart, evt);
        };
      }
    },

    createDynamicVolChart(stats, chartId, chartOpt) {
      let opt = chartOpt.options;
      const counts = [];
      let labels = [];
      let dataSets = [];
      let set = [];

      let highest_user_val = [];
      stats.map(data => {
        set = [];
        labels = [];
        data.dates.map(item => {
          set.push(item.count);
          labels.push(item.date);
        });
        let color = this.random_rgba();
        this.selectedSubTab !== "TOTAL"
          ? dataSets.push({
              type: "line",
              label: data.user.full_name,
              fill: false,
              borderColor: color, //"rgba(186,231,85,0.9)",
              borderWith: 1,
              backgroundColor: color,
              pointBackgroundColor: color,
              pointBorderColor: color,
              pointHoverBackgroundColor: color,
              pointHoverBorderColor: color,
              data: set,
              hidden:
                this.selectedSubTab === "AVG" ||
                highest_user_val.push(set.reduce((a, b) => a + b))
            })
          : "";
      });
      let totalAvg = [];
      let totalCount = [];
      if (this.selectedSubTab === "AVG") {
        for (const i in labels) {
          let tempAvg =
            stats.reduce((a, b) => a + b.dates[i].count, 0) / stats.length;
          totalAvg.push(tempAvg.toFixed(1));
        }
        let color = this.random_rgba();
        dataSets.push({
          type: "line",
          label: "AVG",
          fill: false,
          borderColor: color, //"rgba(186,231,85,0.9)",
          borderWith: 1,
          backgroundColor: "#e755ba",
          pointBackgroundColor: color,
          pointBorderColor: color,
          pointHoverBackgroundColor: color,
          pointHoverBorderColor: color,
          data: totalAvg
        });
      }
      if (this.selectedSubTab === "TOTAL") {
        for (const i in labels) {
          let tempCount = stats.reduce((a, b) => a + b.dates[i].count, 0);
          totalCount.push(tempCount);
        }
        let color = this.random_rgba();
        dataSets.push({
          type: "line",
          label: "TOTAL",
          fill: false,
          borderColor: color, //"rgba(186,231,85,0.9)",
          borderWith: 1,
          backgroundColor: "#e755ba",
          pointBackgroundColor: color,
          pointBorderColor: color,
          pointHoverBackgroundColor: color,
          pointHoverBorderColor: color,
          data: totalCount
        });
      }
      if (this.selectedSubTab !== "AVG" && this.selectedSubTab !== "TOTAL") {
        let idx = highest_user_val.indexOf(
          Math.max.apply(Math, highest_user_val)
        );
        dataSets[idx].hidden = false;
      }
      if (opt.annotation) {
        opt.annotation = null;
      }
      if (counts.length > 0) {
        opt.annotation = this.returnAverageLine(
          counts.reduce((a, b) => a + b) / counts.length,
          true,
          "rgba(0,89,149,0.83)",
          255
        );
      }
      const data = {
        labels: labels,
        datasets: dataSets
      };

      if (this.depChart) {
        this.depChart.destroy();
      }
      const ctx = document.getElementById(chartId);
      this.depChart = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
    },

    createDepositsVolChart(stats, chartId, chartOpt) {
      let opt = chartOpt.options;
      let regCounts = [];
      let depCounts = [];
      let labels = [];
      let dataSets = [];
      let set = [];

      stats.map(data => {
        if (data.registered === 0 && data.deposits === 0) {
          return;
        }
        regCounts.push(data.registered);
        depCounts.push(data.deposits);
        labels.push(data.date);
      });

      if (this.generalQueryObject.hasOwnProperty("registered_on_from")) {
        this.dpDates = [
          this.generalQueryObject.registered_on_from
            .split("-")
            .reverse()
            .join("-"),
          this.generalQueryObject.registered_on_to
            .split("-")
            .reverse()
            .join("-"),
          this.diffTimeInDaysForNaChartTitle(
            this.generalQueryObject.registered_on_from,
            this.generalQueryObject.registered_on_to
          )
        ];
      } else {
        this.dpDates = null;
      }

      this.dPcounters.units = labels.length;

      this.dPcounters.dp = depCounts.reduce((a, b) => a + b);
      let sets = [
        {
          type: "line",
          label: "REGISTERED",
          fill: false,
          borderColor: "rgb(3,161,222)",
          borderWith: 1,
          backgroundColor: "#e755ba",
          pointBackgroundColor: "rgb(3,161,222)",
          pointBorderColor: "rgb(3,161,222)",
          pointHoverBackgroundColor: "rgb(3,161,222)",
          pointHoverBorderColor: "rgb(3,161,222)",
          data: regCounts
        },
        {
          type: "line",
          label: "DEPOSITS",
          fill: false,
          borderColor: "rgb(200,3,222)",
          borderWith: 1,
          backgroundColor: "#e755ba",
          pointBackgroundColor: "rgb(200,3,222)",
          pointBorderColor: "rgb(200,3,222)",
          pointHoverBackgroundColor: "rgb(200,3,222)",
          pointHoverBorderColor: "rgb(200,3,222)",
          data: depCounts
        }
      ];
      if (opt.annotation) {
        opt.annotation = null;
      }
      // if (counts.length > 0) {
      //   opt.annotation = this.returnAverageLine(
      //     counts.reduce((a, b) => a + b) / counts.length,
      //     true,
      //     "rgba(0,89,149,0.83)",
      //     255
      //   );
      // }
      const data = {
        labels: labels,
        datasets: sets
      };

      if (this.DynamicChartBuild) {
        this.DynamicChartBuild.destroy();
      }
      const ctx = document.getElementById(chartId);
      this.DynamicChartBuild = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
    },

    setPresetFromTab(subTab, mainTab, setTab = null) {
      if (subTab.presetTab) {
        this.$store.commit("clients/setSelectedCalendarType", {
          alias: this.mainCalendarSection,
          preset: subTab.alias
        });
      } else {
        this.setMatrixView(mainTab);
      }
      if (setTab) {
        if (this.selectedTab !== mainTab.alias) {
          this.TabClick(mainTab);
        }
      }
    },
    setMatrixView(tab) {
      this.matrixView = true;
    },
    closeMatrix() {
      this.matrixView = false;
    },
    resetTabFilter(subTab) {
      let tab = subTab.toUpperCase();
      let mainObj = Object.assign({}, this.clickFromChart);
      if (mainObj.data.hasOwnProperty(this.mainSector)) {
        mainObj.data[this.mainSector][tab] = false;
      } else {
        mainObj.data[this.mainSector] = {
          [tab]: false
        };
      }
      mainObj.lastSector = this.mainSector;
      mainObj.subSector = this.selectedTab;
      this.$store.commit("clients/setClickFromChart", mainObj);
    },
    checkFilterTab(subTab) {
      let tab = subTab.toUpperCase();
      let mainObj = Object.assign({}, this.clickFromChart);
      if (mainObj.data.hasOwnProperty(this.mainSector)) {
        if (mainObj.data[this.mainSector].hasOwnProperty(tab)) {
          if (mainObj.data[this.mainSector][tab]) {
            return true;
          }
        }
      }
      return false;
    },
    clickGoalChart(opt, myChart, evt) {
      const activePoints = myChart.getElementsAtEvent(evt);
      if (activePoints[0]) {
        const chartData = activePoints[0]["_chart"].config.data;
        const idx = activePoints[0]["_index"];

        //   const label = chartData.labels[idx];
        //     const value = chartData.datasets[0].data[idx];

        if (!this.checkIfCalendarSelected()) {
          this.$store.commit("clients/setSelectedCalendarType", {
            alias: this.mainCalendarSection,
            preset: "TODAY"
          });
        }
        //
        // this.$store.commit("clients/setCalendarDates", {
        //   calendar: this.mainCalendarSection,
        //   dates: {
        //     start: data.dates[0],
        //     end: data.dates[1]
        //   }
        // });
      }
    },
    resetMainFilters() {
      this.mainFilters = {
        deposit_at_from: moment(this.defaultPresets().start).format(
          "YYYY-MM-DD"
        ),
        deposit_at_to: moment(this.defaultPresets().end).format("YYYY-MM-DD"),
        special_req: true
      };
    },
    random_rgba() {
      let o = Math.round,
        r = Math.random,
        s = 255;
      return "rgb(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + ")";
    },
    clickOnChart(chart, evt, ids) {
      let activePoints = chart.getElementAtEvent(evt);
      if (activePoints[0]) {
        let idx = activePoints[0]["_index"];
        let selectedId = ids[idx];
        let mainObj = Object.assign({}, this.clickFromChart);
        if (mainObj.data.hasOwnProperty(this.mainSector)) {
          mainObj.data[this.mainSector][this.selectedTab] = [
            { id: selectedId }
          ];
        } else {
          mainObj.data[this.mainSector] = {
            [this.selectedTab]: [{ id: selectedId }]
          };
        }
        mainObj.lastSector = this.mainSector;
        mainObj.subSector = this.selectedTab;
        this.$store.commit("clients/setClickFromChart", mainObj);

        if(!this.showReset){
          this.$store.commit("clients/setSelectedCalendarType", {
            alias: this.mainCalendarSection,
            preset: 'TODAY'
          });
        }

      }
    },
    closeSubTab() {
      this.openSubTab = false;
    },


  }
};
</script>

<style scoped>
.main-graph-window {
  width: 100%;
  min-height: 200px;
  background-color: #fff;
  /*padding-top: 5px;*/
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  overflow: hidden;
}

.dropdown-item {
  height: 35px;
  min-height: 8%;
  /*padding: 1px 0px;*/
  /*margin: 0px;*/
  border-radius: 5px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  /*border-radius: 5px 0px 0px 5px;*/
  /*border-radius: 0px 5px 5px 0px;*/
  //margin-bottom: 1px;
  background-color: white;
  border: 1px solid #e5e4e4;
  position: relative;
  z-index: 1;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-item.cal-match {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  margin-right: 36px;
}
.menu-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.menu-wrapper::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.menu-wrapper::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
.menu-wrapper {
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 12px;
  /*padding-top: 12px;*/
  padding-right: 5px;
  /*padding-bottom: 12px;*/
  padding-left: 12px;
  transform: scaleX(-1);
  margin-left: 5px;
  max-height: 195px;
}
.sub-menu-dropdown {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
  transform: scaleX(-1);
}

.dropdown-item-left {
  margin-left: 10px;
  /*float: left;*/
  flex: 1;
  font-weight: 500;
}
.dropdown-item-right {
  width: 14px;
}
.dropdown-menu.tabs-menu{
  max-width: 200px;
  min-width: 100%;
  overflow-y: visible;
  padding:5px;
}
.chart-section {
  flex: 2;
  width: 55%;
  min-height: 100%;
  max-height: 200px;
  display: flex;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
}
.deposit-chart {
  width: 100%;
  min-height: 100%;
}
.longTitleFontSize {
  font-size: 11px;
}

li.active {
  background-color: #c12fff;
  color: #fff;
}
.sized_chart {
  /*max-width: 80%;*/
  /*position: relative;*/
}
.trans-dep-chart {
  position: relative;
  max-width: 13%;
  min-width: 13%;
  max-height: 100%;
  margin-left: 3px;
}
.dep-goal-chart {
  position: relative;
  max-width: 9%;
  min-width: 9%;
  max-height: 100%;
  margin-left: 3px;
}

.sub-menu-main {
  left: 67px;
  top: -1px;
  position: absolute;
  display: flex;
  max-height: 20px;
}

.sub-menu-main li {
  background-color: #f5f7ff;
  color: #0a0a0a;
  cursor: pointer;
  transform: none !important;
  max-height: 20px;
  margin-left: 1px;
  border-radius: 0px;
}
.sub-menu-main li:hover {
  cursor: pointer;
  background-color: #dedede;
}
.sub-menu-main li.active {
  background-color: #c12fff;
  color: #fff;
}
.preset-tab {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  /*max-width: 52px;*/
  margin-left: 3px;
}
.preset-tab:hover {
  background: #d7d7d7;
}
.preset-tab:active {
  background: #a8a5a5;
}
.preset-tab.active {
  background-color: #c12fff;
  color: #fff;
}
.preset-tab {
  margin-top: unset;
}
.preset-tab:focus {
  outline: none;
}
.dropdown-item-left.sub {
  margin-left: unset;
  width: fit-content;
  text-align: center;
}
.loading {
  background: linear-gradient(-45deg, #c12fff, #43006b, #c12fff, #43006b);
  background-size: 500% 500%;
  animation: gradient 3s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 0%;
  }

  100% {
    background-position: 100% 50%;
  }
}

/*::-webkit-scrollbar {*/
/*  display: none;*/
/*}*/
.arrow-down {
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #d2f;
  font-size: 29px;
  cursor: pointer;
}

.disabled_scroll {
  display: none;
}
.cancel-filter {
  margin-top: 2px;
  margin-left: 5px;
}

.presets-container {
  height: 20px;
  margin: 0px;
  padding: 0px;
  display: flex;
  /*position: absolute;*/
  /*top: 35px;*/
  /*left: 91px;*/
  position: relative;
  top: -8px;
  left: -75px;
  z-index: 0;
}
.pre-btn:focus {
  outline: none;
}
.pre-btn {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sub-menu-presets-tab {
  /*max-width: 57px !important;*/
  /*min-width: 57px !important;*/
  display: flex;
  flex-direction: row;
  margin-left: 63px;
  border: none;
  top: -7px;
  background: none;
}

.fa-caret-right {
  padding-left: 3px;
}
#mmain-chart-dep-sub-gn {
  padding-bottom: 7px;
  height: 169px;
}
.top-bar {
  display: flex;
  justify-content: space-evenly;
  background-color: #efefef;
  width: 100%;
  height: 15px;
  font-size: 10px;
  position: absolute;
  top: 23px;
  left: 73px;
}
.inner-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
}
.charts-main {
  flex: 2;
  width: 80%;
  min-height: 100%;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
}
.stats-btn {
  color: #4275ec;
  font-weight: bold;
}
.stats-btn-for-line {
  color: #4275ec;
  font-weight: bold;
}
.for-line-btns {
  display: flex;
  flex-direction: row;
}
span.for-diff-in-days {
  padding-left: 8px;
}

.for-canvas-dp {
  height: 160px !important;
  padding-top: 10px !important;
}
/*.sub-sector{*/
/*  min-width: 100%;*/
/*  margin-left: 0px;*/
/*  border-radius: 5px;*/
/*}*/
.tabs-sector-main{
  min-width: 70px;
}
</style>
